import React from "react";
import { Redirect } from "react-router-dom";
import { recaptchaSiteKey } from "../config";
import { Typography } from "@material-ui/core";
import Reaptcha from 'reaptcha';

import Form from "./common/form";
import userService from "../services/userService";
import auth from "../services/authService";
import authService from "../services/authService";
import { toast } from "react-toastify";
import { fieldValidator } from "./common/fieldValidator";

export class RegisterForm extends Form {
  state = {
    data: {
      email: "",
      email_confirm: "",
      password: "",
      password_confirm: "",
      name: "",
      accept_terms: false,
      accept_privacy: false,
      invoice_name: "",
      invoice_city: "",
      invoice_zip: "",
      invoice_address: "",
      invoice_taxcode: "",
      invoice_email: "",
    },
    captchaResponse: "",
    errors: {},
    isSubmitting: false,
  };
  
  /** @type {Reaptcha | null} */
  captchaRef = null;

  mapRegistrationErrors = (apiErrors = {}) => ({
    name: apiErrors["Name"],
    email: apiErrors["Email"],
    password: apiErrors["Password"],
    captcha: apiErrors["Captcha"],
    invoice_name: apiErrors["InvoiceName"],
    invoice_zip: apiErrors["InvoiceZip"],
    invoice_city: apiErrors["InvoiceCity"],
    invoice_address: apiErrors["InvoiceAddress"],
    invoice_taxcode: apiErrors["InvoiceTaxCode"],
    invoice_email: apiErrors["InvoiceEmail"],
  });

  componentDidUpdate(prevProps, prevState) {
    let errors = this.state.errors;

    if(this.state.data.accept_terms !== prevState.data.accept_terms){
      if(this.state.data.accept_terms){
        errors["accept_terms"] = null;
        this.setState({ errors });
      } else {
        errors["accept_terms"] = 'A felhasználási feltételek elfogadása kötelező';
        this.setState({ errors });
      }
    }
    if(this.state.data && this.state.data.accept_privacy !== prevState.data.accept_privacy){
      if(this.state.data.accept_privacy){
        errors["accept_privacy"] = null;
        this.setState({ errors });
      } else {
        errors["accept_privacy"] = 'Az adatkezelési feltételek elfogadása kötelező';
        this.setState({ errors });
      }
    }

    if(this.state.data && this.state.data.password !== this.state.data.password_confirm){
      if(errors["password_confirm"] == null) {
        errors["password_confirm"] = 'Nem egyezik';
        this.setState({ errors });
      }
    } else {
      errors["password_confirm"] = null;
    }
    
    if(this.state.data && this.state.data.email !== this.state.data.email_confirm){
      if(errors["email_confirm"] == null) {
        errors["email_confirm"] = 'Nem egyezik';
        this.setState({ errors });
      }
    } else {
      errors["email_confirm"] = null;
    }   
  }

  doSubmit = async () => {
    await this.doRegistrationSubmit();
  };

  doRegistrationSubmit = async () => {
    if (this.state.isSubmitting) return;

    const errors = {};
	const requiredFields = [
	  "name", "email", "email_confirm", "password", "password_confirm",
	  "invoice_name", "invoice_zip", "invoice_city", "invoice_address",
	  "invoice_taxcode", "invoice_email"
	];
	requiredFields.forEach(field => {
	  errors[field] = fieldValidator(field, this.state.data[field]);
	});

	if (this.state.data.password !== this.state.data.password_confirm) {
	  errors.password_confirm = "Nem egyezik";
	}
	if (this.state.data.email !== this.state.data.email_confirm) {
	  errors.email_confirm = "Nem egyezik";
	}
	if (!this.state.captchaResponse) {
	  errors.captcha = "Kötelező mező";
	}

    if (!this.state.data.accept_terms) {
      errors.accept_terms = "A felhasználási feltételek elfogadása kötelező";
    }

    if (!this.state.data.accept_privacy) {
      errors.accept_privacy = "Az adatkezelési feltételek elfogadása kötelező";
    }

	this.setState({ errors });
	if (Object.values(errors).some(Boolean)) {
      return;
    }

	this.setState({ isSubmitting: true });
    try {
      const response = await userService.register(
        this.state.data,
        this.state.captchaResponse
      );
      auth.loginWithJwt(response.data.token);
      document.location = "/w/subscriptions";
    } catch (ex) {
      if (ex.response && ex.response.status === 422) {
        this.setState({
          errors: {
            ...errors,
            ...this.mapRegistrationErrors(ex.response.data.errors),
          }
        });
		this.setState({ captchaResponse: "" });
		if (this.captchaRef) await this.captchaRef.reset();
      } else if (ex.response && ex.response.status === 401) {
        await auth.logout();
        toast.error("A regisztráció sikerült, de az automatikus bejelentkezés hibás volt. Kérjük, jelentkezzen be újra.");
      }
	} finally {
	  this.setState({ isSubmitting: false });
    }
  };

  renderSubscribeFields = () => {
    return (
      <div>
        {this.renderInput("invoice_name", "Számlázási név", "text", true)}
        {this.renderInput(
          "invoice_zip",
          "Számlázási irányítószám",
          "text",
          true
        )}
        {this.renderInput("invoice_city", "Számlázási város", "text", true)}
        {this.renderInput(
          "invoice_address",
          "Számlázási utca, hsz.",
          "text",
          true
        )}
        {this.renderInput("invoice_taxcode", "Adószám", "text", true)}
        <Typography>Külföldi adóalany esetén kérjük vegye fel velünk a kapcsolatot. Magánszemélyként írjon 0-t!</Typography>
        {this.renderInput(
          "invoice_email",
          "Elektronikus számlázási e-mail",
          "text",
          true
        )}
      </div>
    );
  };

  captchaVerified = (response) => {
    this.setState({ captchaResponse: response, errors: {} });
  };

  render() {
    if (authService.getCurrentUser()) {
      return <Redirect to="/w/profile" />;
    }

    let errorMessages = Object.values(this.state.errors);
    let numberOfErrors = errorMessages.filter(Boolean);
	let isDisabled = numberOfErrors.length > 0 || this.state.isSubmitting;

    return (
      <div>
        <h1>Regisztráció</h1>
        <form onSubmit={this.handleSubmit}>
          {this.renderInput("name", "Név", "text", true)}
          {this.renderInput("email", "E-mail", "text", true)}
          {this.renderInput("email_confirm", "E-mail megerősítés", "text", true)}
          {this.renderInput("password", "Jelszó", "password", true)}
          {this.renderInput("password_confirm", "Jelszó megerősítés", "password", true)}
          {this.renderSubscribeFields()}
          {this.renderCheckbox(
            "accept_terms",
            <a href="https://legter.hu/aszf/" target="_blank">
              Felhasználási feltételek elfogadása
            </a>
          )}
          {this.renderCheckbox(
            "accept_privacy",
            <a
              href="https://legter.hu/rolunk/adatvedelmi-tajekoztato/"
              target="_blank"
            >
              Adatkezelési feltételek elfogadása
            </a>
          )}
          <br />
          <Reaptcha
            ref={(ref) => this.captchaRef = ref}
            sitekey={recaptchaSiteKey}
            onVerify={this.captchaVerified}
          />
          {this.state.errors.captcha && <span>Captcha: {this.state.errors.captcha}</span>}
          <br />
          {this.renderButton("Regisztráció", isDisabled)}
        </form>
      </div>
    );
  }
}

export default RegisterForm;
